module.exports = __webpack_public_path__ + "img/v_up1.3e96bb15.png";